export const REGION = "eu-west-2"; 
export const IDENTITY_POOL_ID = "eu-west-2:bc2e646f-3ec7-44ac-bb69-1dc72071f9a1"; 